import { statsIDToKey, statsKeyToID } from "../../../constants/constants";
import actions from "../../../store/actions";

export default class MqttVehicleMap {
  vehicleMap = {};
  isInitialBucket = true;
  groupMerged = false;

  mergeGroup = (treeRaw, users) => {
    let vehicles = window.vehicleMap;
    this.groupMerged = true; // Now this.groupMerged refers to the class property
    let vehicleMapByPPath = {};
    let gpaths;

    for (let idx in vehicles) {
      gpaths = vehicles[idx].groupinfo;
      for (let jdx in gpaths) {
        let ppath = gpaths[jdx][0];
        if (!(ppath in vehicleMapByPPath)) {
          vehicleMapByPPath[ppath] = [];
        }
        vehicleMapByPPath[ppath].push(vehicles[idx]);
      }
    }

    let checkedGroup = localStorage.getItem("checkpath")
      ? JSON.parse(localStorage.getItem("checkpath"))
      : null;
    let byLevel = {};
    let level;
    let highestLevel = 0;
    let lowestLevel = 1000;

    for (let idx in treeRaw) {
      level = treeRaw[idx].path.split("/").length - 2;
      if (level > highestLevel) highestLevel = level;
      if (level < lowestLevel) lowestLevel = level;
      if (!(level in byLevel)) {
        byLevel[level] = {};
      }
      if (!checkedGroup) {
        treeRaw[idx].checked = true;
      }
      for (let cdx in checkedGroup) {
        if (checkedGroup[cdx].path === treeRaw[idx].path) {
          treeRaw[idx].checked = true;
        }
      }
      treeRaw[idx].children = [];
      treeRaw[idx].vehicles = [];
      if (treeRaw[idx].groupid in vehicleMapByPPath) {
        treeRaw[idx].vehicles = [
          ...(vehicleMapByPPath[treeRaw[idx].groupid] || []),
        ];
      }
      byLevel[level][treeRaw[idx].path] = treeRaw[idx];
    }

    let children = [];

    for (let idx = highestLevel; idx > lowestLevel; idx--) {
      if (byLevel[idx - 1]) {
        for (let jdx in byLevel[idx]) {
          if (byLevel[idx][jdx].ppath in byLevel[idx - 1]) {
            byLevel[idx][jdx].hasParent = true;
            byLevel[idx - 1][byLevel[idx][jdx].ppath].children.push(
              byLevel[idx][jdx]
            );
          }
        }
      }
    }

    Object.keys(byLevel).forEach((group) => {
      for (let sgroup in byLevel[group]) {
        if (!byLevel[group][sgroup].hasParent) {
          children.push(byLevel[group][sgroup]);
        }
      }
    });

    if (Object.keys(byLevel).length > 0) {
      for (let idx in byLevel[lowestLevel]) {
        byLevel[lowestLevel][idx].expanded = true;
        if (!children.includes(byLevel[lowestLevel][idx])) {
          children.push(byLevel[lowestLevel][idx]);
        }
      }
      children.push({
        name: "Users",
        checked: true,
        groupid: 0,
        users: [...(users || [])],
      });

      this.tree = {
        children,
        name: "Groups",
        checked: true,
        groupid: 0,
        expanded: true,
      };
    }
    return this.tree;
  };

  updateVM = (data, gotAllBuckets) => {
    let gpslist = data.gps.msglist;
    this.updateStats(data);
    for (let index in gpslist) {
      let vehicle = gpslist[index];
      if (
        (vehicle.lt < -85.05115 ||
          vehicle.lt > 85.05115 ||
          vehicle.ln < -180 ||
          vehicle.ln > 180) &&
        vehicle.fq === 0
      ) {
        vehicle.lt = 0;
        vehicle.ln = 0;
      }

      // let rtgps = {...vehicle};
      // console.log("vehicle", vehicle)
      // console.log("rtgps", rtgps)
      if (!vehicle.vm && !gotAllBuckets) {
        console.warn("Vehicle Meta Not found [" + vehicle.vp + "]");
        continue;
      }

      // delete rtgps.vm;
      if (vehicle.vm) {
        // vehicle = vehicle.vm;
        // vehicle.vp = rtgps.vp;
        vehicle.vm.vp = vehicle.vp;
        let newvehicle = this.processVehicleMeta(vehicle.vm, vehicle);
        window.vehicleMap = this.vehicleMap;
        this.processRTGPS(newvehicle, vehicle);
      }
    }
    // console.log(gpslist);

    if (!this.isInitialBucket && data.gps.bucketid === 0) {
      this.updateVMInstance();
    }
    if (this.isInitialBucket) {
      this.isInitialBucket = false;
    }
    let progress = {
      totalVehicles: data.totalvehcount,
      loadedVehicles: Object.keys(this.vehicleMap).length,
    };
    progress.progress = Math.ceil(
      (progress.loadedVehicles / progress.totalVehicles) * 100
    );
    window.updateVehicleLoadedProgress(progress);
  };

  updateStats = (data) => {
    let stats = {};
    let key;

    //console.log('data.stats', data.stats.length)
    for (let idx in data.stats) {
      key = statsIDToKey(data.stats[idx].key);
      stats[key] = data.stats[idx].count;
    }

    window.dispatchStoreEvent({
      type: actions.STATS_UPDATED,
      data: stats,
    });
  };

  isVehicleMetaProcessed = (vehicle) => !(vehicle.vp in this.vehicleMap);

  processVehicleMeta = (vehicle, rtgps) => {
    if (this.isVehicleMetaProcessed(vehicle)) {
      vehicle.processed = true;
      // console.log("processVehicleMeta", vehicle.vp)

      let onroad = (rtgps.bci || []).filter((d) => d.bucketid === 0).length
        ? true
        : false;

      let newVehicle = {
        vehicleno: vehicle.vehicleno,
        vehicleid: vehicle.vp,
        id: vehicle.vp,
        fueltankcapacity: vehicle.modelinfo.fueltankcapacity,
        fueltankcapacity2: vehicle.modelinfo.fueltankcapacity2,
        type: "vehicle",
        vehiclemeta: {
          onroad,
          installation_type: vehicle.installation_type,
          chassisno: vehicle.chassisno,
          oem: vehicle.modelinfo.oem,
          transmission: vehicle.modelinfo.transmission,
          model: vehicle.modelinfo.model,
          variant: vehicle.modelinfo.variant,
          odofrom: vehicle.odofrom,
          odocalibration: vehicle.odocalibration,
          fueltype: vehicle.modelinfo.fueltype,
          modelid: vehicle.modelinfo.modelid,
          fueltankcapacity: vehicle.modelinfo.fueltankcapacity,
          numfueltanks: vehicle.modelinfo.numfueltanks,
          num_fuelsensors: vehicle.modelinfo.numfuelsensors,
          immobilize_type: vehicle.immobilize_type,
          charge_control: vehicle.charge_control,
          discharge_control: vehicle.discharge_control,
          chargeValidation:
            vehicle.chargedischarge_validation === true
              ? true
              : vehicle.chargedischarge_validation === "true"
              ? true
              : vehicle.chargedischarge_validation,
          // program: null,
          // B: null,
          // notes: null,
          // remarks: null,
          // enginecc: null,
          // fitment_date: null,
          // fitment_location: null,
        },
        vehicleModel: vehicle.modelinfo,
        vehiclemodel: vehicle.modelinfo.model,
        vehiclechassisno: vehicle.chassisno,
        devices: {},
        deviceTypesList: [],
        groupinfo: [],
        groupnames: "",
        groups: [],
        singleSearchStr: null,
      };

      for (let idx in vehicle.deviceinfo) {
        newVehicle.devices[vehicle.deviceinfo[idx].bindtag] = {
          deviceno: vehicle.deviceinfo[idx].deviceno,
          devicetype: vehicle.deviceinfo[idx].devicetype, //
        };
        newVehicle[vehicle.deviceinfo[idx].bindtag + "_deviceno"] =
          vehicle.deviceinfo[idx].deviceno;
        newVehicle.deviceTypesList.push(vehicle.deviceinfo[idx].devicetype);
      }

      for (let idx in vehicle.groups) {
        let gid = vehicle.groups[idx].path;
        gid = gid.split("/");
        gid = parseInt(gid[gid.length - 2]);
        newVehicle.groupinfo.push([
          gid,
          vehicle.groups[idx].path,
          vehicle.groups[idx].name,
        ]);
        newVehicle.groups.push({
          name: vehicle.groups[idx].name,
          groupid: gid,
          path: vehicle.groups[idx].path,
          pname: "",
          ppath: "",
          groupnamepath: "",
        });
        newVehicle.groupnames += " " + vehicle.groups[idx].name;
      }
      this.vehicleMap[vehicle.vp] = newVehicle;
      return newVehicle;
    }
    return this.vehicleMap[vehicle.vp];
  };

  processRTGPS = (vehicle, rtgps) => {
    // console.log("processRTGPS", vehicle)
    vehicle.filters = (rtgps.bci || []).map((d) => statsIDToKey(d.bucketid));
    window.onInMapGPS([rtgps], "GPS");
  };

  updateVMInstance = () => {
    window.vehicleMap = this.vehicleMap;
    if (this.updateStoreVM) {
      this.updateStoreVM(this.vehicleMap);
    }
  };
}
// export const mergeGroup = (treeRaw, users) => {
//   //  console.log("users",users)
//   let vehicles = window.vehicleMap;
//   this.groupMerged = true;
//   let vehicleMapByPPath = {};
//   let gpaths;

//   for (let idx in vehicles) {
//     gpaths = vehicles[idx].groupinfo;
//     for (let jdx in gpaths) {
//       let ppath = gpaths[jdx][0];
//       if (!(ppath in vehicleMapByPPath)) {
//         vehicleMapByPPath[ppath] = [];
//       }
//       vehicleMapByPPath[ppath].push(vehicles[idx]);
//     }
//   }

//   let checkedGroup = localStorage.getItem("checkpath")
//     ? JSON.parse(localStorage.getItem("checkpath"))
//     : null;
//   let byLevel = {};
//   let level;
//   let highestLevel = 0;
//   let lowestLevel = 1000;
//   for (let idx in treeRaw) {
//     level = treeRaw[idx].path.split("/").length - 2;
//     if (level > highestLevel) highestLevel = level;
//     if (level < lowestLevel) lowestLevel = level;
//     if (!(level in byLevel)) {
//       byLevel[level] = {};
//     }
//     if (!checkedGroup) {
//       treeRaw[idx].checked = true;
//     }
//     for (let cdx in checkedGroup) {
//       if (checkedGroup[cdx].path === treeRaw[idx].path) {
//         treeRaw[idx].checked = true;
//       }
//     }
//     treeRaw[idx].children = [];
//     treeRaw[idx].vehicles = [];
//     if (treeRaw[idx].groupid in vehicleMapByPPath) {
//       treeRaw[idx].vehicles = [
//         ...(vehicleMapByPPath[treeRaw[idx].groupid] || []),
//       ];
//     }
//     byLevel[level][treeRaw[idx].path] = treeRaw[idx];
//   }
//   let children = [];

//   for (let idx = highestLevel; idx > lowestLevel; idx--) {
//     if (byLevel[idx - 1]) {
//       for (let jdx in byLevel[idx]) {
//         if (byLevel[idx][jdx].ppath in byLevel[idx - 1]) {
//           byLevel[idx][jdx].hasParent = true;
//           byLevel[idx - 1][byLevel[idx][jdx].ppath].children.push(
//             byLevel[idx][jdx]
//           );
//         } else {
//           // children.push(byLevel[idx][jdx])
//         }
//       }
//     }
//   }

//   Object.keys(byLevel).map((group) => {
//     for (let sgroup in byLevel[group]) {
//       if (!byLevel[group][sgroup].hasParent) {
//         children.push(byLevel[group][sgroup]);
//       }
//     }
//   });
//   if (Object.keys(byLevel).length > 0) {
//     for (let idx in byLevel[lowestLevel]) {
//       byLevel[lowestLevel][idx].expanded = true;
//       if (!children.includes(byLevel[lowestLevel][idx])) {
//         children.push(byLevel[lowestLevel][idx]);
//       }
//     }
//     children.push({
//       name: "Users",
//       checked: true,
//       groupid: 0,
//       users: [...(users || [])],
//     });

//     this.tree = {
//       children,
//       name: "Groups",
//       checked: true,
//       groupid: 0,
//       expanded: true,
//     };
//   }
//   return this.tree;
// };
export const mergeGroup = (treeRaw, users) => {
  const mqttVehicleMap = new MqttVehicleMap();
  return mqttVehicleMap.mergeGroup(treeRaw, users);
};
